import * as svg from "../../../assets/info-circle-solid-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const InfoCircleSolidIcon = iconBuilder(svg, "InfoCircleSolidIcon", "0 0 16 16");
